export interface TeamsChannel {
    channelId: string;
    channelName: string;
    teamId: string;
    teamName: string;
    teamSmtpAddress: string;
    createdDateTime?: string;
    isSavedInCalendar?: boolean;
    channelInfoLoadingState?: TeamsChannelInfoLoadingState;
    isVisible?: boolean;
}

export interface TeamsTeam {
    name: string;
    key: string;
    smtpAddress: string;
    profilePictureUrl: string;
    channels: string[];
    isVisible?: boolean;
}

export enum TeamsChannelInfoLoadingState {
    Loading, // Spinner
    Added, // Checkmark
    Error, // Exclamation
    NotSet, // Unchecked
}
